"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachAccessTokensPanel = void 0;
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var kaleidoscope_2 = require("@qwilr/kaleidoscope");
var kaleidoscope_3 = require("@qwilr/kaleidoscope");
var kaleidoscope_4 = require("@qwilr/kaleidoscope");
var mobx_1 = require("mobx");
var mobx_react_1 = require("mobx-react");
var react_1 = __importDefault(require("react"));
var react_transition_group_1 = require("react-transition-group");
var SettingsCard_1 = __importDefault(require("Settings/SettingsCard/SettingsCard"));
var AccessTokenItem_1 = __importDefault(require("SettingsAngular/ApiSettings/AccessTokensPanel/AccessTokenItem"));
var AccessTokensPanel = (function (_super) {
    __extends(AccessTokensPanel, _super);
    function AccessTokensPanel() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.accessTokens = [];
        _this.addEmptyAccessToken = function () {
            _this.accessTokens.unshift({ id: null, description: "" });
        };
        _this.handleAdd = function (accessToken) { return __awaiter(_this, void 0, Promise, function () {
            var validationErrors, token;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        validationErrors = [];
                        if (!accessToken.description) {
                            validationErrors.push({ field: "description", error: "Please enter a description" });
                        }
                        if (validationErrors.length) {
                            return [2, validationErrors];
                        }
                        return [4, this.props.accessTokensApiService.createAccessToken(accessToken.description)];
                    case 1:
                        token = _a.sent();
                        this.accessTokens = this.accessTokens.filter(function (token) { return token.id != accessToken.id; });
                        return [4, this.props.modalService.showAcknowledgeModal({
                                title: "API access token",
                                explainer: "Copy this token and store it in a safe place. You won’t be able to see it again after closing this.",
                                buttonLabel: "I’ve pasted it in a safe place",
                                body: (react_1.default.createElement("div", { className: "access-tokens-panel__modal-body" },
                                    react_1.default.createElement(kaleidoscope_3.CopyInput, { labelHidden: true, value: token.jwt, label: "API token" }))),
                            })];
                    case 2:
                        _a.sent();
                        this.accessTokens.unshift({ id: token.accessToken._id, description: token.accessToken.description });
                        return [2];
                }
            });
        }); };
        _this.handleDelete = function (accessToken) { return __awaiter(_this, void 0, Promise, function () {
            var revokeToken;
            var _this = this;
            return __generator(this, function (_a) {
                revokeToken = function () { return __awaiter(_this, void 0, Promise, function () {
                    var revoked;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (accessToken.id === null) {
                                    return [2, false];
                                }
                                return [4, this.props.accessTokensApiService.revokeAccessToken(accessToken.id)];
                            case 1:
                                revoked = _a.sent();
                                if (revoked) {
                                    this.accessTokens = this.accessTokens.filter(function (token) { return token.id !== accessToken.id; });
                                }
                                return [2, revoked];
                        }
                    });
                }); };
                if (accessToken.id != null) {
                    return [2, this.props.modalService.showDeleteModal({
                            header: "Revoke token ".concat(accessToken.description, "?"),
                            confirming: revokeToken,
                            confirmLabel: "Revoke",
                            isEscapable: true,
                        })];
                }
                this.accessTokens = this.accessTokens.filter(function (token) { return token.id !== accessToken.id; });
                return [2, true];
            });
        }); };
        return _this;
    }
    AccessTokensPanel.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, Promise, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this;
                        return [4, this.props.accessTokensApiService.getAccessTokens()];
                    case 1:
                        _a.accessTokens = _b.sent();
                        return [2];
                }
            });
        });
    };
    AccessTokensPanel.prototype.render = function () {
        var _this = this;
        return (react_1.default.createElement("section", { className: "setting-section access-tokens-panel" },
            react_1.default.createElement(SettingsCard_1.default, { icon: react_1.default.createElement(icons_1.ListBullet, null), heading: "API access tokens", description: react_1.default.createElement(react_1.default.Fragment, null,
                    "Manage access tokens for use with the api. For info on how to get started using an access token, visit the",
                    " ",
                    react_1.default.createElement(kaleidoscope_1.Link, { href: "https://docs.qwilr.com/docs/getting-started/quick-start" }, "quick start guide"),
                    "."), showDivider: true, action: react_1.default.createElement(kaleidoscope_1.IconButton, { isRound: true, type: kaleidoscope_2.ButtonType.Secondary, icon: react_1.default.createElement(icons_1.Add, null), tooltip: { content: "Add new", position: kaleidoscope_1.TooltipPosition.Top }, onClick: this.addEmptyAccessToken }) },
                react_1.default.createElement("div", null,
                    react_1.default.createElement("div", { className: "access-tokens-panel__row-header" },
                        react_1.default.createElement("div", { className: "access-tokens-panel__column-key" },
                            react_1.default.createElement("span", { className: "access-tokens-panel__header" }, "Description"))),
                    react_1.default.createElement(react_transition_group_1.TransitionGroup, null, this.accessTokens.map(function (accessToken) {
                        var _a;
                        return (react_1.default.createElement(react_transition_group_1.CSSTransition, { key: (_a = accessToken.id) !== null && _a !== void 0 ? _a : undefined, timeout: kaleidoscope_4.AnimationDuration.Medium },
                            react_1.default.createElement(AccessTokenItem_1.default, { accessToken: accessToken, onAdd: _this.handleAdd, onDelete: _this.handleDelete })));
                    }))))));
    };
    var _a;
    __decorate([
        mobx_1.observable,
        __metadata("design:type", typeof (_a = typeof Array !== "undefined" && Array) === "function" ? _a : Object)
    ], AccessTokensPanel.prototype, "accessTokens", void 0);
    AccessTokensPanel = __decorate([
        mobx_react_1.observer
    ], AccessTokensPanel);
    return AccessTokensPanel;
}(react_1.default.Component));
exports.default = AccessTokensPanel;
var attachAccessTokensPanel = function (mountReactComponent, accessTokensApiService, modal) {
    return mountReactComponent(react_1.default.createElement(AccessTokensPanel, { accessTokensApiService: accessTokensApiService, modalService: modal }));
};
exports.attachAccessTokensPanel = attachAccessTokensPanel;
